import React from "react";
import { Grid } from "@mui/material";
import { minValue, NumberInput, required } from "react-admin";
import { MoneyInput } from "server/components/Fields/MoneyInput";

const SaveForm = () => (
  <Grid
    container
    spacing={2}
  >
    <Grid
      item
      xs={12}
      md={6}
    >
      <MoneyInput
        source="price"
        label="Дневна такса (EUR)"
      />
    </Grid>
    <Grid
      item
      xs={12}
      md={6}
    >
      <NumberInput
        source="year"
        label="Година"
        validate={[required(), minValue(2025)]}
      />
    </Grid>
  </Grid>
);

export default SaveForm;
